import initData from 'init-data';

const isEnabled = key => {
    return (
        initData && initData.featureSwitches && initData.featureSwitches[key]
    );
};

export const errors = {
    ELASTIC_MYTRADERA:
        'Just nu har vi driftstörningar på delar av Mitt Tradera. Vi arbetar på att lösa problemet.'
};

// ATTENTION!
// Do not any more dependencies to initData.featureSwitches!
// Feature switches MUST be read from Redux.
// The functions below must only be used in MyTradera and the only
// reason they are still here is because it requires large changes
// to MyTradera to get rid of them.
export default {
    isBuyerOrderInformationEnabled: isEnabled('buyer-order-information'),
    isDisputesEntranceEnabled: isEnabled('disputes-entrance'),
    isLeaveFeedbackReactEnabled: isEnabled('leave-feedback-react'),
    isMyTraderaElasticEnabled: isEnabled('mytradera-elasticsearch'),
    isMessagingEnabled: isEnabled('messaging'),
    isMessagingBuyerButtonsEnabled: isEnabled(
        'messaging-contact-buyer-buttons'
    ),
    isMessagingSellerButtonsEnabled: isEnabled(
        'messaging-contact-seller-buttons'
    ),
    downloadCsvPayouts: isEnabled('download-csv-payouts'),
    isInrPurchaseOrderEnabled: isEnabled('inr-purchaseorder'),
    isUpiPurchaseOrderEnabled: isEnabled('upi-purchaseorder'),
    isPennybridgeCharitiesEnabled: isEnabled('pennybridge-charities'),
    isShippingCheckoutEditChangeProviderEnabled: isEnabled(
        'shipping-checkout-edit-change-provider'
    ),
    isSyiShippingAlertPriceIncreaseEnabled: isEnabled(
        'syi-shipping-alert-price-increase'
    ),
    isShippingCheckoutSwishHandelPaymentReactEnabled: isEnabled(
        'shipping-checkout-swish-handel-payment-react'
    ),
    isShippingCheckoutPaymentInvoiceReactEnabled: isEnabled(
        'shipping-checkout-payment-invoice-react'
    ),
    isShippingCheckoutOverviewReact: isEnabled(
        'shipping-checkout-overview-react'
    )
};
